import { useContext } from "react";
import { AuthContext } from "../Pages/Auth/AuthContext";

export const useUserRole = () => {
  const { authData } = useContext(AuthContext);
  return authData?.roleId;
};
